import styled from 'styled-components';
import { palette } from 'styled-tools';

export const PollWrapper = styled.div`
	// background-color: ${palette('gray1')};
`;
